import { RouterProvider } from "react-router";

import { AppProviders } from "@/app/AppProviders";
import { SocketConnectionManager } from "@/app/SocketConnectionManager";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { SessionBootstrap } from "@/features/identity/components/SessionBootstrap";
import { router } from "@/routes/router";

/**
 * The composition root. `ErrorBoundary` wraps everything, including the
 * providers, because a provider failing to initialize is exactly the kind
 * of unexpected error it exists to catch — nesting it inside
 * `AppProviders` would leave it unable to protect against a
 * provider-level failure. `SessionBootstrap` sits inside `AppProviders`
 * (it needs Redux/Query context) but outside the router (route guards must
 * never run before it resolves). `SocketConnectionManager` sits alongside
 * it, inside `AppProviders` too (needs Redux) — the socket connection must
 * survive route changes, so it's mounted here, not inside any one page.
 */
export function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <SessionBootstrap>
          <SocketConnectionManager />
          <RouterProvider router={router} />
        </SessionBootstrap>
      </AppProviders>
    </ErrorBoundary>
  );
}
